import { Alignment } from "@mcleod/core";
import {
    Button, ButtonProps, ButtonVariant, Component,
    TableRowToolsViewer, TableRowToolsViewerBehavior, PanelProps
} from "@mcleod/components";

const baseToolProps: Partial<ButtonProps> = {
    variant: ButtonVariant.text,
    imageAlign: Alignment.TOP,
    height: "100%",
    fillRow: true,
    fillHeight: true,
    rowBreak: false,
    focusable: true,
    margin: 0,
    padding: 0,
    borderRadius: 0,
    borderWidth: 0
};

export class AppTableRowToolsViewerBehavior extends TableRowToolsViewerBehavior {
    protected constructor() {
        super();
    }

    override get defaultProps(): Partial<PanelProps> {
        return {
            height: "100%",
            borderRadius: 0,
            padding: 0,
            margin: 0
        }
    }

    override addTools(viewer: TableRowToolsViewer, ellipsisButton: Button, ...tools: Component[]) {
        tools.forEach(tool => {
            if (tool instanceof Button) {
                this.setToolProps(tool);
                viewer.add(tool);
            }
        });
    }

    private setToolProps(tool: Button): void {
        this.setToolAppProps(tool);

        tool.setProps({
            ...baseToolProps,
            caption: tool.displayLabel,
            color: tool.appProps?.color || tool.color,
            backgroundColor: tool.appProps?.backgroundColor || tool.backgroundColor,
        });
        tool._element.style.pointerEvents = 'auto';
    }

    private setToolAppProps(tool: Component): void {
        tool.appProps ??= {};
        tool.appProps.backgroundColor ??= tool.color
        tool.appProps.color ??= "white";
    }
}

AppTableRowToolsViewerBehavior.register();
